import { render } from "./SpeakingIndicator.vue?vue&type=template&id=4a148986&scoped=true"
import script from "./SpeakingIndicator.vue?vue&type=script&lang=js"
export * from "./SpeakingIndicator.vue?vue&type=script&lang=js"

import "./SpeakingIndicator.vue?vue&type=style&index=0&id=4a148986&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a148986"]])

export default __exports__